import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import _notification from 'modules/notification';
import { Card, Table, Modal, Icon } from 'antd';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopup from '../popup/ConfirmPopup';
import MyInput from 'components/controls/MyInput';
import ButtonComponent from 'components/controls/Button';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import DropdownList from 'components/controls/DropdownList';
import CKEditorComponent from '../../components/controls/CKEditorComponent';

class AkshepData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: { pageSize: 10, current: 1 },
            data: [],
            rowData: {
                "Id": "",
                "BatchName": "",
                "AakshepMessage": "",
                "StartRoleNumber": "",
                "EndRoleNumber": "",
            },
            loading: false,
            showModel: false,
            highlightedRowID: null,
            showMessageBox: false,
            batchNameError: "",
            startRoleNumberError: "",
            endRoleNumberError: "",
            AakshepMessageError: "",
        };
    }

    componentDidMount() {
        this.getAllStudentAakshepData();
    }

    getAllStudentAakshepData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let studentAakshepList = await _AdminService.GetAllStudentAakshepData();
                    //  console.log("studentAakshepList Data: ", studentAakshepList.data);

                    this.setState({
                        data: studentAakshepList.data.Obj,
                        loading: false,
                    });
                } catch (e) {
                    this.setState({ loading: false });
                    //console.log('Error: ', e);
                }
            });
        } catch (e) {
            this.setState({ loading: false });
            //console.log('Error: ', e);
        }
    };

    handleUpdate = async () => {

        if (this.validateFormData()) {
            return;
        }
        const params = {
            Id: this.state.rowData.Id,
            BatchName: this.state.rowData.BatchName.trim(),
            AakshepMessage: this.state.rowData.AakshepMessage.trim(),
            StartRoleNumber: this.state.rowData.StartRoleNumber,
            EndRoleNumber: this.state.rowData.EndRoleNumber,
        };

        try {
            this.setState({ loading: true });

            const response = await _AdminService.AddOrUpdateStudentAakshepData(params);

            if (response.status === 200) {
                const message = params.Id === 0 ? "Saved successfully." : "Updated successfully.";
                _notification.showMessage('success', message);
                this.setState({
                    showModel: false,
                    loading: false,
                    highlightedRowID: params.Id,
                });

                // Call to refresh the data after save/update
                this.getAllStudentAakshepData();
            } else {
                _notification.showMessage('error', response.data.message || 'An error occurred');
            }
        } catch (e) {
            this.setState({ loading: false });
            console.log('Error: ', e);
            _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
        }
    };

    deletePost = async () => {
        try {
            if (!this.state.rowData || !this.state.rowData.Id) {
                _notification.showMessage('error', "No valid ID provided.");
                return;
            }
            this.setState({ loading: true });
            //console.log("Deleting Candidate with ID:", this.state.rowData.Id);

            const response = await _AdminService.DeleteStudentAakshepData(this.state.rowData.Id);
            //console.log("Post response:", response);

            if (response.status === 200 && response.data.IsSuccess) {
                _notification.showMessage('success', "Candidate Aakshep Data deleted successfully.");
                this.setState({
                    showModel: false,
                    loading: false,
                    rowData: null, // Clear rowData after successful deletion
                });
                // Fetch updated data 
                this.getAllStudentAakshepData();
            } else {
                _notification.showMessage('error', response.data.Message || "An error occurred while deleting.");
                this.setState({ loading: false });
            }
        } catch (e) {
            console.error("Error during deletion:", e); // Log the actual error
            _notification.showMessage('error', "An error occurred while deleting the data.");
            this.setState({ loading: false });
        }
    }

    onDeleteClick = (value) => {
        //console.log('Delete clicked for: ', value);

        this.setState({
            rowData: value,  // Store the data to be deleted
            showMessageBox: true,
            highlightedRowID: value.Id || 0
        });
    };

    onConfirmDelete = () => {
        //console.log('Confirm delete for ID: ', this.state.rowData?.Id);
        this.setState({ showMessageBox: false });
        this.deletePost();
    };

    onEditClick = async (value) => {

        const response = await _AdminService.GetStudentAakshepData(value.Id);

        this.setState({
            rowData: response.data.Obj,
            showModel: true,           // Show the model/dialog
            highlightedRowID: value.Id // Set the highlighted row ID to the clicked row's ID
        }, () => {
            window.scrollTo(0, 0);
        });
    };

    onTableAction = (pagination, filters, sorter, extra) => {
        this.setState({
            pagination: pagination,
            highlightedRowID: null
        });
    }

    closeMessageBox(value = false) {
        this.setState({ showMessageBox: value });
    }

    onAddNewRecordClick = (modelToggle) => {
        this.setState({
            showModel: modelToggle,  // Show or hide the model based on modelToggle
            rowData: { Id: 0, BatchName: '', AakshepMessage: '', StartRoleNumber: '', EndRoleNumber: '' }, // Reset rowData to default state for a new record
        });
    }

    hideModelWindow() {
        this.setState({ showModel: false, rowData: {} });
    }

    onTextChange = ({ target: { name, value } }) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [name]: value }
        });
    }

    validateFormData = () => {
        const body = this.state.rowData;
        let hasError = false;

        this.setState({
            batchNameError: "",
            startRoleNumberError: "",
            endRoleNumberError: "",
            AakshepMessageError: "",
        });

        if (!body.BatchName || !body.BatchName.trim()) {
            this.setState({ batchNameError: 'Please enter a valid Batch Name' });
            hasError = true;
        }

        if (!body.StartRoleNumber && body.StartRoleNumber !== 0) {
            this.setState({ startRoleNumberError: 'Please enter a valid Start Role Number' });
            hasError = true;
        } else if (!/^\d+$/.test(body.StartRoleNumber)) {
            this.setState({ startRoleNumberError: 'Start Role Number must only contain digits' });
            hasError = true;
        }

        if (!body.EndRoleNumber && body.EndRoleNumber !== 0 || body.EndRoleNumber < body.StartRoleNumber) {
            this.setState({ endRoleNumberError: 'Please enter a valid End Role Number (greater than Start Role Number)' });
            hasError = true;
        } else if (!/^\d+$/.test(body.EndRoleNumber)) {
            this.setState({ endRoleNumberError: 'End Role Number must only contain digits' });
            hasError = true;
        }

        if (!body.AakshepMessage || !body.AakshepMessage.trim()) {
            this.setState({ AakshepMessageError: 'Please enter a valid Aakshep Message' });
            hasError = true;
        }

        return hasError;
    };


    handleModelChange = (stateName, model) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [stateName]: model }
        });
    }

    render() {
        const TableColumns = [
            {
                title: 'Batch Name',
                dataIndex: 'BatchName',
                key: 'BatchName',
            },
            {
                title: 'Aakshep Message',
                dataIndex: 'AakshepMessage',
                key: 'AakshepMessage',
                render: (value) => {
                    return (
                        <div dangerouslySetInnerHTML={{ __html: value }}></div>
                    );
                }
            },
            {
                title: 'Start Role Number',
                dataIndex: 'StartRoleNumber',
                key: 'StartRoleNumber',
                render: (value) => value !== null ? value : 'N/A' // handle null case
            },
            {
                title: 'End Role Number',
                dataIndex: 'EndRoleNumber',
                key: 'EndRoleNumber',
                render: (value) => value !== null ? value : 'N/A'
            },
            {
                title: 'Action',
                dataIndex: '',
                key: 'Id',
                width: "20%",
                render: (value) => {
                    return (
                        <>
                            <ButtonComponent type="button" value="Edit" className="button-global button-border small autoHeight mr-2" onClick={(event) => this.onEditClick(value)} />
                            <ButtonComponent type="button" value="Delete" className="button-global button-danger small autoHeight" onClick={(event) => this.onDeleteClick(value)} />
                        </>
                    );
                }
            },
        ];


        if (this.state.loading)
            return <LoadingSpinner />

        return (<>

            <div className="container-fluid p-3">
                <PageHeader
                    title="Aakshep Data"
                    breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Masters' }, { label: 'Aakshep Data' }]}
                />
                <div className="analysisWrap">
                    <div style={{ textAlign: 'right' }}>
                        {!this.state.showModel &&
                            <div className="max1200 m-auto mb-2">
                                <div className="d-flex align-items-center justify-content-end">
                                    <a className="button-global button-border addbutton autoWidth d-inline-block text-center autoHeight mb-3  d-flex align-items-center justify-content-center"
                                        onClick={() => this.onAddNewRecordClick(true)}><Icon type="plus-circle" className="mr-2 font1rem" /> Add Candidate Aakshep Data</a>

                                </div>
                            </div>
                        }
                    </div>

                    {/* Modal controls */}
                    {this.state.showModel &&
                        <div className="max1200 m-auto">
                            <div className="ent-panel mb-4">
                                <h4 className="heading4">{this.state.rowData ? this.state.rowData.Id > 0 ? "Update" : "Add" : "Add"} Candidate Aakshep Data </h4>

                                <div className="admin-inner-wrap p-3">

                                    <div className="row flex-sm-row ">

                                        <div className="col-sm-4">
                                            <label htmlFor="category">Batch Name<span className="color-red">*</span></label>
                                            <MyInput id="BatchName"
                                                type="text"
                                                key="BatchName"
                                                name="BatchName"
                                                value={this.state.rowData.BatchName || ""}
                                                onChange={this.onTextChange}
                                                placeholder={"Enter Batch Name"}
                                                isRequired={true}
                                                errorState={this.state.batchNameError}
                                                errorMessage={this.state.batchNameError} />
                                        </div>

                                        <div className="col-sm-4">
                                            <label htmlFor="category">Start Roll Number<span className="color-red">*</span></label>
                                            <MyInput id="StartRoleNumber"
                                                type="text"
                                                key="StartRoleNumber"
                                                name="StartRoleNumber"
                                                value={this.state.rowData.StartRoleNumber || ""}
                                                onChange={this.onTextChange}
                                                placeholder={"Enter Start Roll Number"}
                                                isRequired={true}
                                                errorState={this.state.startRoleNumberError}
                                                errorMessage={this.state.startRoleNumberError} />
                                        </div>

                                        <div className="col-sm-4">
                                            <label htmlFor="category">End Roll Number<span className="color-red">*</span></label>
                                            <MyInput id="EndRoleNumber"
                                                type="text"
                                                key="EndRoleNumber"
                                                name="EndRoleNumber"
                                                value={this.state.rowData.EndRoleNumber || ""}
                                                onChange={this.onTextChange}
                                                placeholder={"Enter End Roll Number"}
                                                isRequired={true}
                                                errorState={this.state.endRoleNumberError}
                                                errorMessage={this.state.endRoleNumberError} />
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row mt-4">
                                        <div className="col-sm-12">
                                            <label htmlFor="category">Aakshep Message<span className="color-red">*</span></label>
                                            <CKEditorComponent
                                                tabIndex="8"
                                                placeholderText="AakshepMessage"
                                                model={this.state.rowData.AakshepMessage}
                                                modelName="AakshepMessage"
                                                handleModelChange={this.handleModelChange}
                                            />
                                            {this.state.AakshepMessageError && (
                                                <div className="color-red">{this.state.AakshepMessageError}</div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                                <div className="pt-4 buttonAlignCenter" >
                                    <button type="button" onClick={() => this.hideModelWindow()} className="button-global button-secondary mr-4 autoHeight small"><span>Cancel</span></button>
                                    <button type="button" onClick={this.handleUpdate} className="button-global button-primary autoHeight small"><span>Save</span></button>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="max1200 m-auto">
                        <Table
                            size="small"
                            bordered
                            rowKey="Id"
                            columns={TableColumns}
                            dataSource={this.state.data}
                            pagination={this.state.pagination}
                            footer={() => (
                                <label style={{ textAlign: 'right', marginRight: '20px' }}>
                                    Total Records: {this.state.data.length}
                                </label>
                            )}
                            onChange={this.onTableAction}
                            rowClassName={(record, index) => {
                                const rowClass = index % 2 ? 'odd' : 'even';
                                return rowClass + (record.Id === this.state.highlightedRowID ? ' scroll-row table-row-dark' : '');
                            }}
                            className="table-striped-rows admin-table"
                        />
                    </div>
                </div>
                <Modal
                    centered={true}
                    width={400}
                    className="modelPopAnt admin-home"
                    visible={this.state.showMessageBox}
                    onCancel={() => this.closeMessageBox(false)}
                    footer={false}
                >
                    <ConfirmPopup
                        onCancel={() => this.closeMessageBox(false)}
                        onOk={this.onConfirmDelete}
                        popupData={this.state.rowData}
                        message="Are you sure, you want to delete this Record?"
                    />
                </Modal>
            </div>


        </>)
    };
}

export default AkshepData;